import React from "react";

export default function BuyerFirstSuccess({ contractId, sellerMobile, onRestart, onGoToPanel }) {
  const link = `${window.location.origin}/seller-contract/${contractId}`;

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4 py-10">
      <div className="w-full max-w-lg">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-3xl">
            ✅
          </div>
          <h1 className="text-xl font-extrabold text-navy">
            اطلاعات خریدار با موفقیت ثبت شد
          </h1>
          <p className="mt-2 text-sm text-gray-500">
            پیامک حاوی لینک قولنامه به شماره{" "}
            <span className="font-bold text-navy">{sellerMobile}</span> ارسال
            شد.
          </p>
        </div>

        <div className="rounded-2xl bg-white p-6 shadow-card">
          <p className="mb-2 text-xs font-bold text-navy-light">
            لینک اختصاصی فروشنده
          </p>
          <div className="flex items-center gap-2 rounded-xl border border-gray-200 bg-surface px-4 py-3">
            <span className="flex-1 truncate text-xs text-gray-600 ltr">
              {link}
            </span>
            <button
              onClick={() => navigator.clipboard.writeText(link)}
              className="shrink-0 rounded-lg bg-sky/10 px-3 py-1.5 text-xs font-bold text-sky-dark transition hover:bg-sky/20"
            >
              کپی
            </button>
          </div>
          <p className="mt-3 text-xs text-gray-400">
            فروشنده با باز کردن این لینک می‌تواند اطلاعات خودرو، شرایط معامله و
            امضای خود را تکمیل کند.
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:justify-center">
          <button
            onClick={onRestart}
            className="rounded-xl border border-gray-200 bg-white px-6 py-2.5 text-sm font-bold text-navy transition hover:border-sky-light"
          >
            ثبت قولنامه جدید
          </button>
          {onGoToPanel && (
            <button
              onClick={onGoToPanel}
              className="rounded-xl bg-navy px-6 py-2.5 text-sm font-bold text-white transition hover:bg-navy-light"
            >
              بازگشت به پنل
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
